import type {
  MyTaskDto,
  MyOverdueTaskDto,
  MyTimeAnalysisDto,
  MyProjectTimeBreakdownDto,
  MyTaskTimeBreakdownDto,
  MyTaskPagedResult,
  MyOverdueTaskPagedResult,
} from '../types';

const myTasksItems: MyTaskDto[] = [
  {
    id: '111222333',
    title: 'Testing de integración',
    projectId: '444555666',
    projectName: 'Plataforma de Análisis',
    projectColor: '#7C3AED',
    statusId: '777888999',
    statusName: 'Completada',
    statusColor: '#22C55E',
    statusType: 'Done',
    priority: 'High',
    dueDate: '2026-02-09T00:00:00Z',
    overdueDays: null,
    estimatedHours: 6.0,
    trackedHours: 5.17,
    efficiencyPercentage: 86.17,
  },
  {
    id: '111222444',
    title: 'Optimizar rendimiento de carga',
    projectId: '999888777',
    projectName: 'Rediseño Web',
    projectColor: '#F59E0B',
    statusId: '555444333',
    statusName: 'Por hacer',
    statusColor: '#94A3B8',
    statusType: 'Todo',
    priority: 'High',
    dueDate: '2026-02-13T00:00:00Z',
    overdueDays: 6,
    estimatedHours: 5.0,
    trackedHours: 0.75,
    efficiencyPercentage: 15.0,
  },
  {
    id: '111222555',
    title: 'Revisar arquitectura de microservicios',
    projectId: '444555666',
    projectName: 'Plataforma de Análisis',
    projectColor: '#7C3AED',
    statusId: '666777888',
    statusName: 'En progreso',
    statusColor: '#3B82F6',
    statusType: 'InProgress',
    priority: 'Medium',
    dueDate: '2026-02-20T00:00:00Z',
    overdueDays: null,
    estimatedHours: 4.0,
    trackedHours: 1.33,
    efficiencyPercentage: 33.25,
  },
  {
    id: '111222666',
    title: 'Documentar API de facturación',
    projectId: '222333444',
    projectName: 'Portal de Clientes',
    projectColor: '#06B6D4',
    statusId: '555444333',
    statusName: 'Por hacer',
    statusColor: '#94A3B8',
    statusType: 'Todo',
    priority: 'Low',
    dueDate: null,
    overdueDays: null,
    estimatedHours: null,
    trackedHours: 0,
    efficiencyPercentage: null,
  },
];

export const mockMyTasks: MyTaskPagedResult = {
  items: myTasksItems,
  page: 1,
  pageSize: 10,
  totalCount: myTasksItems.length,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: myTasksItems.length,
};

const myOverdueTasksItems: MyOverdueTaskDto[] = [
  {
    id: '111222444',
    title: 'Optimizar rendimiento de carga',
    projectId: '999888777',
    projectName: 'Rediseño Web',
    projectColor: '#F59E0B',
    dueDate: '2026-02-13T00:00:00Z',
    delayDays: 6,
    priority: 'High',
    statusId: '555444333',
    statusName: 'Por hacer',
    statusColor: '#94A3B8',
    blockedReason:
      'Bloqueado a la espera de acceso a los servidores de producción para realizar pruebas de rendimiento',
  },
  {
    id: '111222777',
    title: 'Migrar base de datos de reportes',
    projectId: '222333444',
    projectName: 'Portal de Clientes',
    projectColor: '#06B6D4',
    dueDate: '2026-02-10T00:00:00Z',
    delayDays: 9,
    priority: 'Urgent',
    statusId: '666777888',
    statusName: 'En progreso',
    statusColor: '#3B82F6',
    blockedReason: null,
  },
];

export const mockMyOverdueTasks: MyOverdueTaskPagedResult = {
  items: myOverdueTasksItems,
  page: 1,
  pageSize: 10,
  totalCount: myOverdueTasksItems.length,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: myOverdueTasksItems.length,
};

const mockByProject: MyProjectTimeBreakdownDto[] = [
  {
    projectId: '444555666',
    projectName: 'Plataforma de Análisis',
    projectColor: '#7C3AED',
    estimatedHours: 10.0,
    trackedHours: 6.5,
    efficiencyPercentage: 65.0,
  },
  {
    projectId: '999888777',
    projectName: 'Rediseño Web',
    projectColor: '#F59E0B',
    estimatedHours: 5.0,
    trackedHours: 0.75,
    efficiencyPercentage: 15.0,
  },
];

const mockByTask: MyTaskTimeBreakdownDto[] = [
  {
    taskId: '111222444',
    taskTitle: 'Optimizar rendimiento de carga',
    estimatedHours: 5.0,
    trackedHours: 0.75,
    efficiencyPercentage: 15.0,
  },
  {
    taskId: '111222555',
    taskTitle: 'Revisar arquitectura de microservicios',
    estimatedHours: 4.0,
    trackedHours: 1.33,
    efficiencyPercentage: 33.25,
  },
  {
    taskId: '111222333',
    taskTitle: 'Testing de integración',
    estimatedHours: 6.0,
    trackedHours: 5.17,
    efficiencyPercentage: 86.17,
  },
];

export const mockMyTimeAnalysis: MyTimeAnalysisDto = {
  totalEstimatedHours: 15.0,
  totalTrackedHours: 7.25,
  overallEfficiencyPercentage: 48.33,
  byProject: mockByProject,
  byTask: mockByTask,
};
